export default __webpack_public_path__ + "static/media/more.c0fa1fc9.svg";